import { createFileRoute } from '@tanstack/react-router'
import IcpDetailPage from '@/components/business-value/IcpDetailPage'
import { energy } from '@/data/business-value'

export const Route = createFileRoute('/_app/business-value/energy')({
  component: EnergyPage,
})

function EnergyPage() {
  return <IcpDetailPage icp={energy} />
}
